import type { AxiosRequestConfig } from 'axios';
import { getRossumAgentAPI } from '@rossum/fabry-api-client';
import {
  absoluteApiUrl,
  mrFabryAgentUrl,
  rossumAgentUrl,
} from '../../constants/config';
import { getAuthToken } from '../../lib/token';
import store from '../../redux/configureStore';
import { userLabConfigSelector } from '../../redux/modules/user/selectors';
import { isFeatureEnabled } from '../feature-enablement/featureEnablement';

export const fabryApi = getRossumAgentAPI();

export const getApiUrl = () =>
  window.localStorage.getItem('REACT_APP_API_URL') || absoluteApiUrl;

// The `mr-fabry-coupacabry` flag switches the whole chat feature between the
// legacy Python agent and the new mr-fabry service. Only mr-fabry serves the
// `/api/v2` endpoints, so callers must gate v2 requests on this.
export const isMrFabryAgent = (): boolean =>
  isFeatureEnabled(
    'mr-fabry-coupacabry',
    userLabConfigSelector(store.getState())
  );

export const getRossumAgentUrl = (): string =>
  isMrFabryAgent() ? mrFabryAgentUrl : rossumAgentUrl;

export const getFabryRequestConfig = (): AxiosRequestConfig => ({
  baseURL: getRossumAgentUrl(),
  headers: {
    'X-Rossum-Token': getAuthToken() ?? '',
    'X-Rossum-Api-Url': getApiUrl(),
  },
});
